import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const SectionHeading1 = ({ text, sx }) => (
  <p
    style={{
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "600",
      marginTop: "1rem",
      marginLeft: "1rem",
      // paddingLeft: "1rem",
      // textIndent: "-1rem",
      lineHeight: "1.5",
      ...sx,
    }}
  >
    {text}
  </p>
);

const GRI403_3 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    occupationalHealthServicesFunctions: "",
    workerHealthInfoConfidentiality: "",
    workerHealthInfoUsageProtection: "",
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview")),
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        const data =
          response.data.data.GRI400?.occupationalHealthServices || {};
        setFormData({
          occupationalHealthServicesFunctions:
            data.occupationalHealthServicesFunctions || "",
          workerHealthInfoConfidentiality:
            data.workerHealthInfoConfidentiality || "",
          workerHealthInfoUsageProtection:
            data.workerHealthInfoUsageProtection || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (!formData.occupationalHealthServicesFunctions) {
      newErrors.occupationalHealthServicesFunctions = "This field is required";
      formIsValid = false;
    }

    if (!formData.workerHealthInfoConfidentiality) {
      newErrors.workerHealthInfoConfidentiality = "This field is required";
      formIsValid = false;
    }

    if (!formData.workerHealthInfoUsageProtection) {
      newErrors.workerHealthInfoUsageProtection = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return; // Validate form before submission
      const payload = {
        type: "GRI400",
        occupationalHealthServices: {
          ...formData,
        },
        submitted403_3: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/403-4/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/403-4/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      {!hide && (
        <p className={styles.section_heading}>
          403 : Occupational Health and Safety
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0rem" }}
      >
        403-3 : Occupational health services
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading text="a. Describe the functions performed by occupational health services that contribute to the identification and elimination of hazards, as well as the minimization of risks? Additionally, please explain the measures taken by the organization to ensure the quality of these services and to facilitate workers' access to them." />
        <CustomTextField
          value={formData.occupationalHealthServicesFunctions}
          onChange={(e) =>
            handleInputChange(
              "occupationalHealthServicesFunctions",
              e.target.value,
            )
          }
          error={errors.occupationalHealthServicesFunctions}
          helperText={errors.occupationalHealthServicesFunctions}
          disabled={disabled}
        />

        <SectionHeading1 text=" How does the organization maintain the confidentiality of workers’ personal health related information " />
        <CustomTextField
          value={formData.workerHealthInfoConfidentiality}
          onChange={(e) =>
            handleInputChange("workerHealthInfoConfidentiality", e.target.value)
          }
          error={errors.workerHealthInfoConfidentiality}
          helperText={errors.workerHealthInfoConfidentiality}
          disabled={disabled}
        />

        <SectionHeading1 text="How does the organization ensures that workers’ personal health-related information and their participation in any occupational health services are not used for any favourable or unfavourable treatment of workers." />
        {/* <p>
          How does the organization ensures that workers’ personal
          health-related information and their participation in any occupational
          health services are not used for any favourable or unfavourable
          treatment of workers.
        </p> */}
        <CustomTextField
          value={formData.workerHealthInfoUsageProtection}
          onChange={(e) =>
            handleInputChange("workerHealthInfoUsageProtection", e.target.value)
          }
          error={errors.workerHealthInfoUsageProtection}
          helperText={errors.workerHealthInfoUsageProtection}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI403_3;
